
import { Translation } from './types';

export const translations: Record<'fr' | 'en', Translation> = {
  fr: {
    navHome: "Accueil",
    navAbout: "À propos",
    navSolutions: "Solutions",
    navDashboard: "Dashboard",
    navTeam: "Équipe",
    navPricing: "Tarifs",
    navFAQ: "FAQ",
    navContact: "Contact",
    heroTitle: "L'IA au service de la Maintenance Prédictive",
    heroSubtitle: "Safe Predictive Innovation transforme vos données industrielles en décisions stratégiques. Réduisez vos coûts de maintenance et éliminez les arrêts non planifiés.",
    heroCTA: "Découvrir nos solutions",
    heroStats1: "Réduction des pannes",
    heroStats2: "Économie moyenne",
    heroStats3: "ROI moyen",
    heroStatsTarget: "Actifs ciblés en France",
    aboutTitle: "Qui sommes-nous",
    aboutPioneer: "Parmi les pionniers de l'IA industrielle en France",
    aboutMainTitle: "Safe Predictive Innovation",
    aboutMainText: "Fondée avec une vision claire : rendre l'industrie plus sûre et plus performante grâce à l'IA. Nous combinons expertise en Data Science et connaissance approfondie des processus industriels (Chimie, Énergie, Manufacturing).",
    missionTitle: "Notre Mission",
    missionText: "Démocratiser l'accès à la maintenance prédictive pour les PME et grands groupes industriels, en fournissant des solutions clés en main et auditables.",
    teamTitle: "L'Équipe",
    teamText: "Une synergie entre ingénierie logicielle et expertise métier. Nous sommes deux associés passionnés par l'optimisation industrielle.",
    visionTitle: "Vision",
    visionText: "Créer un standard industriel où l'arrêt imprévu devient une exception du passé.",
    whyTitle: "Pourquoi nous choisir ?",
    why1: "Approche sur-mesure adaptée à vos capteurs existants.",
    why2: "Respect strict de la confidentialité de vos données industrielles.",
    why3: "Accompagnement de la collecte de données jusqu'au déploiement.",
    aboutQuote: "La maintenance de demain se construit aujourd'hui.",
    simulatorTitle: "Simulateur de Diagnostic IA",
    simulatorSubtitle: "Testez la puissance de notre modèle. Décrivez un symptôme technique et obtenez une analyse préliminaire instantanée.",
    simulatorPlaceholder: "Ex: Vibration excessive sur la pompe centrifuge P-102 avec hausse de température",
    simulatorBtn: "Lancer le Diagnostic",
    simulatorResultTitle: "Résultat de l'analyse",
    simulatorCause: "CAUSE PROBABLE",
    simulatorRecom: "RECOMMANDATION",
    simulatorImpact: "Impact estimé",
    simulatorImpactDesc: "Ceci est une simulation. Pour intégrer ce modèle avec vos données réelles (SCADA, IoT), contactez-nous.",
    simulatorDiscuss: "Discuter de mon cas d'usage →",
    solutionsTitle: "Solutions sectorielles",
    solutionsSubtitle: "Une expertise pointue adaptée à chaque environnement industriel critique.",
    chemTitle: "Chimie",
    chemDesc: "Surveillance des réacteurs et colonnes de distillation pour éviter les fuites et optimiser les cycles.",
    chemDetails: "Nos algorithmes avancés surveillent en permanence les réacteurs et les colonnes. En détectant les micro-variations de pression et de température, nous prévenons les emballements thermiques et optimisons la consommation de réactifs pour une production plus sûre et plus rentable.",
    energyTitle: "Énergie",
    energyDesc: "Analyse des turbines et réseaux de distribution pour une stabilité maximale du réseau.",
    energyDetails: "Maximisez la disponibilité de vos actifs de production d'énergie. Nos solutions analysent les spectres vibratoires des turbines et générateurs pour identifier les défauts de roulements ou de désalignement des semaines avant la panne.",
    metalTitle: "Métallurgie",
    metalDesc: "Monitoring des fours haute température et laminoirs pour prévenir les défaillances mécaniques.",
    metalDetails: "Dans des environnements extrêmes, la fiabilité est clé. Nous surveillons l'usure des équipements critiques comme les laminoirs et les fours à arc, permettant de planifier les remplacements de pièces lors des arrêts programmés uniquement.",
    petroTitle: "Pétrochimie",
    petroDesc: "Optimisation de l'intégrité des infrastructures et détection précoce de corrosion.",
    petroDetails: "La sécurité est la priorité. Notre IA détecte les signes précurseurs de corrosion et de fuite sur les infrastructures vieillissantes, assurant la conformité environnementale et la sécurité des installations.",
    agroTitle: "Agroalimentaire",
    agroDesc: "Garantie de la chaîne de froid et maintenance préventive des lignes de conditionnement automatisées.",
    agroDetails: "Évitez les pertes de produits périssables. Nous assurons le bon fonctionnement des systèmes de réfrigération et des lignes de conditionnement à haute cadence, garantissant la qualité et la traçabilité.",
    autoTitle: "Automobile",
    autoDesc: "Maintenance prédictive des bras robotisés et lignes d'assemblage haute cadence.",
    autoDetails: "Zéro arrêt non planifié sur la ligne d'assemblage. Nous anticipons les défaillances des bras robotiques et des systèmes de convoyage pour maintenir le flux tendu (Just-In-Time) essentiel à l'industrie automobile.",
    dashboardTitle: "Supervision Intelligente",
    dashboardLive: "Interface Opérateur",
    dashboardAlert: "Alerte de maintenance détectée",
    dashboardOverview: "Vue d'ensemble",
    dashboardAssetHealth: "Santé Globale",
    dashboardPredictions: "Pannes Évitées",
    dashboardUptime: "Disponibilité",
    dashboardChartTitle: "Analyse Vibratoire & Tendance",
    dashboardSideOverview: "Accueil",
    dashboardSideAssets: "Mes Actifs",
    dashboardSideAlerts: "Alertes",
    dashboardSideReports: "Rapports",
    dashboardSideSettings: "Réglages",
    dashboardBreadcrumb: "Dashboard / Usine Lyon-01 / Pompe P-102",
    dashboardStatusTitle: "Actif : Pompe Centrifuge P-102",
    dashboardStatusSub: "Programme : Maintenance Prédictive IA • Démarrage : 12 Oct 2024",
    missionsTitle: "Nos Missions",
    m1Title: "Détection d'Anomalies",
    m1Desc: "Algorithmes non-supervisés capables d'identifier les déviations subtiles dans les signatures vibratoires ou thermiques.",
    m2Title: "Estimation RUL",
    m2Desc: "Calcul de la durée de vie utile restante (Remaining Useful Life) pour planifier les interventions au moment optimal.",
    m3Title: "Optimisation de Process",
    m3Desc: "Ajustement dynamique des paramètres de production pour réduire l'usure tout en maintenant le rendement.",
    m4Title: "Gestion des Actifs",
    m4Desc: "Tableaux de bord unifiés pour suivre l'état de santé de l'ensemble de votre parc machine.",
    m5Title: "Edge Computing",
    m5Desc: "Déploiement de modèles légers directement sur vos automates pour une latence zéro.",
    m6Title: "Efficacité Énergétique",
    m6Desc: "Corrélation entre l'état machine et la consommation pour réduire l'empreinte carbone.",
    partnersTitle: "Partenaires & Investisseurs en préparation",
    pricingTitle: "Abonnements sur mesure",
    planStarter: "Starter",
    planStarterDesc: "Idéal pour les PME",
    planStarterF1: "Jusqu'à 10 équipements connectés",
    planStarterF2: "Alertes prédictives basiques",
    planStarterF3: "Support email",
    planStarterF4: "Rapports mensuels",
    planStarterF5: "Accès au dashboard",
    planPro: "Professional",
    planProDesc: "Pour les entreprises en croissance",
    planProF1: "Jusqu'à 50 équipements connectés",
    planProF2: "Alertes avancées avec seuils personnalisés",
    planProF3: "Support prioritaire 24/7",
    planProF4: "Rapports hebdomadaires",
    planProF5: "Formation équipe",
    planProF6: "API d'intégration",
    planEnterprise: "Enterprise",
    planEnterpriseDesc: "Pour les grands groupes industriels",
    planEnterpriseF1: "Équipements illimités",
    planEnterpriseF2: "Modèles IA sur mesure",
    planEnterpriseF3: "Account manager dédié",
    planEnterpriseF4: "Support sur site",
    planEnterpriseF5: "Intégration personnalisée",
    planEnterpriseF6: "SLA garanti",
    planEnterpriseF7: "Formation complète",
    faqTitle: "Questions Fréquentes",
    contactTitle: "Contactez-nous",
    contactSend: "Envoyer le message",
    contactSending: "Envoi en cours...",
    contactSuccess: "Merci pour votre message ! Notre équipe vous recontactera très prochainement.",
    contactError: "Une erreur est survenue. Veuillez réessayer plus tard.",
    contactNew: "Envoyer un autre message",
    footerRights: "Tous droits réservés.",
    quote: "Demander un devis",
    privacyLink: "Politique de confidentialité",
    legalLink: "Mentions légales",
    placeholderName: "Votre nom",
    placeholderEmail: "Votre email",
    placeholderMsg: "Votre message",
    founder1Name: "Brahim Atallah",
    founder1Role: "Fondateur & CEO",
    founder1Bio: "Technicien avec plus de 10 ans d'expérience chez Air Liquide. Expert en maintenance industrielle et diagnostic terrain.",
    founder2Name: "Wajih Aouida",
    founder2Role: "Co-founder & CTO",
    founder2Bio: "Ingénieur IA et Data Scientist. Expert en intelligence artificielle et analyse de données appliquées à l'industrie.",
    faq1Q: "Comment fonctionne votre solution de maintenance prédictive ?",
    faq1A: "Notre solution collecte les données de vos capteurs et équipements industriels, puis utilise des modèles d'IA pour analyser ces données et prédire les pannes potentielles avant qu'elles ne surviennent.",
    faq2Q: "Quels types d'équipements pouvez-vous surveiller ?",
    faq2A: "Nous pouvons surveiller tout type d'équipement industriel équipé de capteurs : moteurs, pompes, compresseurs, turbines, réacteurs, convoyeurs, robots, etc.",
    faq3Q: "Combien de temps faut-il pour voir des résultats ?",
    faq3A: "En général, nos clients commencent à voir des résultats tangibles après 4 à 6 semaines d'utilisation, une fois que nos modèles IA ont appris le comportement normal de leurs équipements.",
    faq4Q: "Mes données sont-elles sécurisées ?",
    faq4A: "Absolument. Nous utilisons des protocoles de sécurité de pointe pour protéger vos données. Vos informations sont chiffrées et hébergées sur des servers sécurisés en conformité avec le RGPD.",
    faq5Q: "Puis-je intégrer votre solution à mes systèmes existants ?",
    faq5A: "Oui, notre solution est conçue pour s'intégrer facilement à vos systèmes existants grâce à notre API REST et nos connecteurs pour les principaux systèmes industriels (SCADA, MES, ERP).",
    faq6Q: "Offrez-vous un service d'installation et de formation ?",
    faq6A: "Oui, nous proposons un service complet d'installation, d'intégration et de formation pour votre équipe afin que vous puissiez tirer le meilleur parti de notre solution."
  },
  en: {
    navHome: "Home",
    navAbout: "About Us",
    navSolutions: "Solutions",
    navDashboard: "Dashboard",
    navTeam: "Team",
    navPricing: "Pricing",
    navFAQ: "FAQ",
    navContact: "Contact",
    heroTitle: "AI at the Service of Predictive Maintenance",
    heroSubtitle: "Safe Predictive Innovation transforms your industrial data into strategic decisions. Reduce maintenance costs and eliminate unplanned downtime.",
    heroCTA: "Discover our solutions",
    heroStats1: "Failure Reduction",
    heroStats2: "Average Savings",
    heroStats3: "Average ROI",
    heroStatsTarget: "Targeted assets in France",
    aboutTitle: "About Us",
    aboutPioneer: "One of the pioneers of industrial AI in France",
    aboutMainTitle: "Safe Predictive Innovation",
    aboutMainText: "Founded with a clear vision: making industry safer and more efficient through AI. We combine Data Science expertise with deep knowledge of industrial processes (Chemistry, Energy, Manufacturing).",
    missionTitle: "Our Mission",
    missionText: "Democratizing access to predictive maintenance for SMEs and large industrial groups by providing turnkey and auditable solutions.",
    teamTitle: "The Team",
    teamText: "A synergy between software engineering and business expertise. We are two partners passionate about industrial optimization.",
    visionTitle: "Vision",
    visionText: "Creating an industrial standard where unplanned downtime becomes an exception of the past.",
    whyTitle: "Why choose us?",
    why1: "Tailor-made approach adapted to your existing sensors.",
    why2: "Strict respect for the confidentiality of your industrial data.",
    why3: "Support from data collection through to deployment.",
    aboutQuote: "The maintenance of tomorrow is built today.",
    simulatorTitle: "AI Diagnostic Simulator",
    simulatorSubtitle: "Test our model's power. Describe a technical symptom and get an instant preliminary analysis.",
    simulatorPlaceholder: "E.g.: Excessive vibration on centrifugal pump P-102 with temperature increase",
    simulatorBtn: "Launch Diagnostic",
    simulatorResultTitle: "Analysis Result",
    simulatorCause: "PROBABLE CAUSE",
    simulatorRecom: "RECOMMENDATION",
    simulatorImpact: "Estimated Impact",
    simulatorImpactDesc: "This is a simulation. To integrate this model with your real data (SCADA, IoT), contact us.",
    simulatorDiscuss: "Discuss my use case →",
    solutionsTitle: "Sector Solutions",
    solutionsSubtitle: "Deep expertise tailored to each critical industrial environment.",
    chemTitle: "Chemistry",
    chemDesc: "Monitoring reactors and distillation columns to prevent leaks and optimize cycles.",
    chemDetails: "Our advanced algorithms continuously monitor reactors and columns. By detecting micro-variations in pressure and temperature, we prevent thermal runaways and optimize reagent consumption for safer and more profitable production.",
    energyTitle: "Energy",
    energyDesc: "Analysis of turbines and distribution networks for maximum grid stability.",
    energyDetails: "Maximize the availability of your energy production assets. Our solutions analyze vibration spectra of turbines and generators to identify bearing faults or misalignment weeks before failure.",
    metalTitle: "Metallurgy",
    metalDesc: "Monitoring high-temperature furnaces and rolling mills to prevent mechanical failures.",
    metalDetails: "In extreme environments, reliability is key. We monitor wear on critical equipment such as rolling mills and arc furnaces, allowing parts replacement to be planned only during scheduled shutdowns.",
    petroTitle: "Petrochemistry",
    petroDesc: "Optimizing infrastructure integrity and early corrosion detection.",
    petroDetails: "Safety is the priority. Our AI detects early signs of corrosion and leakage on aging infrastructure, ensuring environmental compliance and installation safety.",
    agroTitle: "Food Industry",
    agroDesc: "Guaranteeing the cold chain and preventive maintenance for automated packaging lines.",
    agroDetails: "Avoid loss of perishable products. We ensure the proper functioning of refrigeration systems and high-speed packaging lines, guaranteeing quality and traceability.",
    autoTitle: "Automotive",
    autoDesc: "Predictive maintenance for robotic arms and high-speed assembly lines.",
    autoDetails: "Zero unplanned downtime on the assembly line. We anticipate failures of robotic arms and conveyor systems to maintain the Just-In-Time flow essential to the automotive industry.",
    dashboardTitle: "Intelligent Supervision",
    dashboardLive: "Operator Interface",
    dashboardAlert: "Maintenance alert detected",
    dashboardOverview: "Overview",
    dashboardAssetHealth: "Global Health",
    dashboardPredictions: "Failures Prevented",
    dashboardUptime: "Availability",
    dashboardChartTitle: "Vibration Analysis & Trend",
    dashboardSideOverview: "Home",
    dashboardSideAssets: "My Assets",
    dashboardSideAlerts: "Alerts",
    dashboardSideReports: "Reports",
    dashboardSideSettings: "Settings",
    dashboardBreadcrumb: "Dashboard / Plant Lyon-01 / Pump P-102",
    dashboardStatusTitle: "Asset: Centrifugal Pump P-102",
    dashboardStatusSub: "Program: AI Predictive Maint • Start: Oct 12, 2024",
    missionsTitle: "Our Missions",
    m1Title: "Anomaly Detection",
    m1Desc: "Unsupervised algorithms identifying subtle deviations in vibration or thermal signatures.",
    m2Title: "RUL Estimation",
    m2Desc: "Remaining Useful Life calculation to plan interventions at the optimal time.",
    m3Title: "Process Optimization",
    m3Desc: "Dynamic adjustment of production parameters to reduce wear while maintaining yield.",
    m4Title: "Asset Management",
    m4Desc: "Unified dashboards to track the health of your entire machine fleet.",
    m5Title: "Edge Computing",
    m5Desc: "Lightweight model deployment directly on your PLCs for zero latency.",
    m6Title: "Energy Efficiency",
    m6Desc: "Correlation between machine state and consumption to reduce carbon footprint.",
    partnersTitle: "Partners & Investors in preparation",
    pricingTitle: "Tailored Subscriptions",
    planStarter: "Starter",
    planStarterDesc: "Ideal for SMEs",
    planStarterF1: "Up to 10 connected devices",
    planStarterF2: "Basic predictive alerts",
    planStarterF3: "Email support",
    planStarterF4: "Monthly reports",
    planStarterF5: "Dashboard access",
    planPro: "Professional",
    planProDesc: "For growing companies",
    planProF1: "Up to 50 connected devices",
    planProF2: "Advanced alerts with custom thresholds",
    planProF3: "24/7 Priority support",
    planProF4: "Weekly reports",
    planProF5: "Team training",
    planProF6: "Integration API",
    planEnterprise: "Enterprise",
    planEnterpriseDesc: "For large industrial groups",
    planEnterpriseF1: "Unlimited devices",
    planEnterpriseF2: "Custom AI models",
    planEnterpriseF3: "Dedicated Account Manager",
    planEnterpriseF4: "On-site support",
    planEnterpriseF5: "Custom integration",
    planEnterpriseF6: "Guaranteed SLA",
    planEnterpriseF7: "Complete training",
    faqTitle: "FAQ",
    contactTitle: "Contact Us",
    contactSend: "Send Message",
    contactSending: "Sending...",
    contactSuccess: "Thank you for your message! Our team will get back to you shortly.",
    contactError: "An error occurred. Please try again later.",
    contactNew: "Send another message",
    footerRights: "All rights reserved.",
    quote: "Get a Quote",
    privacyLink: "Privacy Policy",
    legalLink: "Legal Mentions",
    placeholderName: "Your name",
    placeholderEmail: "Your email",
    placeholderMsg: "Your message",
    founder1Name: "Brahim Atallah",
    founder1Role: "Founder & CEO",
    founder1Bio: "Technician with over 10 years of experience at Air Liquide. Expert in industrial maintenance and field diagnostics.",
    founder2Name: "Wajih Aouida",
    founder2Role: "Co-founder & CTO",
    founder2Bio: "AI Engineer and Data Scientist. Expert in artificial intelligence and data analysis applied to industry.",
    faq1Q: "How does your predictive maintenance solution work?",
    faq1A: "Our solution collects data from your industrial sensors and equipment, then uses AI models to analyze this data and predict potential failures before they occur.",
    faq2Q: "What types of equipment can you monitor?",
    faq2A: "We can monitor any type of industrial equipment equipped with sensors: motors, pumps, compressors, turbines, reactors, conveyors, robots, etc.",
    faq3Q: "How long does it take to see results?",
    faq3A: "In general, our clients start seeing tangible results after 4 to 6 weeks of use, once our AI models have learned the normal behavior of their equipment.",
    faq4Q: "Is my data secure?",
    faq4A: "Absolutely. We use state-of-the-art security protocols to protect your data. Your information is encrypted and hosted on secure servers in compliance with GDPR.",
    faq5Q: "Can I integrate your solution into my existing systems?",
    faq5A: "Yes, our solution is designed to easily integrate with your existing systems thanks to our REST API and our connectors for the main industrial systems (SCADA, MES, ERP).",
    faq6Q: "Do you offer an installation and training service?",
    faq6A: "Yes, we offer a full installation, integration and training service for your team so that you can get the most out of our solution."
  }
};
